import _ from 'lodash';
import app from '$$app';
import rights from '../../../../components/rights';
import routerHelper from '$$routerHelper';
import dnd_arrow from '../../../../svg/dnd_arrow.svg';
import getSvgIcon from '../../helpers/getSvgIcon';

class Dnd {
  #isChangingProjectsOrderInMultiview = false;

  #instance = null;

  isDragging = false;

  isAborting = false;

  #globalTaskId = null;

  init(instance) {
    this.#instance = instance;
    this.#instance.config.order_branch = 'marker';
    this.#instance.config.order_branch_free = true;
  }

  onRowDragStart(id, target, e) {
    const draggingTask = this.#instance.isTaskExists(id) ? this.#instance.getTask(id) : null;

    if (!draggingTask) return;
    if (!rights.project.hasRight(draggingTask.gantt_id, 'drag_and_drop')) {
      return;
    }

    if (routerHelper.isTaskSettingsRoute()) {
      return false;
    }

    if (draggingTask.$level === 0) {
      return false;
    }

    if (draggingTask.type === this.#instance.config.types.button) {
      return false;
    }

    this.isDragging = true;
    this.isAborting = false;
    userExtAnalytics.log('gantt_task_grid_drag_start');

    return true;
  }

  onBeforeRowDragMove(id, parent) {
    const draggingTask = this.#instance.isTaskExists(id) ? this.#instance.getTask(id) : null;
    const newParent = this.#instance.isTaskExists(parent) ? this.#instance.getTask(parent) : null;

    if (+id < 0) {
      return false;
    }

    if (!newParent || !draggingTask) {
      return false;
    }

    if (this.#instance.config.multiview && draggingTask.$level !== 1 && newParent.$level === 0) {
      return false;
    }

    // drag inside itself
    if (draggingTask.id === newParent.id) {
      return false;
    }

    if (newParent.type === this.#instance.config.types.button) {
      return false;
    }

    return true;
  }

  onRowDragMove(id, targetId, targetIndex) {
    const task = this.#instance.getTask(id);
    const target = this.#instance.getTask(targetId);

    const dndTask = document.getElementsByClassName('gantt_drag_marker')[0];
    const dndTaskMarker = document.getElementsByClassName('gantt_grid_dnd_marker')[0];

    if (dndTask && dndTask.childNodes[0].childNodes[4].classList && dndTask.childNodes[0].childNodes[4].closest('.tooltip-gantt')) {
      dndTask.childNodes[0].childNodes[4].classList.remove('tooltip-gantt');
    }

    // Dnd task icon
    if (!dndTask.querySelector('.task-icon')) {
      const icon = document.createElement('div');

      if (task.type === 'project') {
        icon.innerHTML = getSvgIcon('project', 'regular', 20);
      } else {
        icon.innerHTML = getSvgIcon('file', 'regular', 20);
      }

      icon.className = 'task-icon';
      dndTask.appendChild(icon);
    }

    // Replace folder marker with line marker for project task
    if (target.type === this.#instance.config.types.project && dndTaskMarker.querySelector('.gantt_grid_dnd_marker_folder')) {
      if (target.$open) {
        const linePos = this.#instance.getProjectLineMarkerPosition(target.id);

        dndTaskMarker.innerHTML = '<div class="gantt_grid_dnd_marker_line"></div>';
        dndTaskMarker.style.left = linePos.x + 'px';
        dndTaskMarker.style.top = linePos.y + 'px';
        dndTaskMarker.style.width = linePos.width + 'px';
      } else {
        this.#openParent(true, target);
      }
    } else {
      this.#openParent(false);
    }

    // Remove previous dnd highlight
    if (this.#globalTaskId) {
      const globalTask = this.#instance.getTaskRowNode(this.#globalTaskId);

      globalTask && globalTask.classList.remove('dnd-highlight');
      this.#globalTaskId = null;
    }

    const markerFolder = dndTaskMarker.querySelector('.gantt_grid_dnd_marker_folder');

    // Dnd highlight
    if (markerFolder) {
      const targetNode = this.#instance.getTaskRowNode(+targetId);

      targetNode.classList.add('dnd-highlight');
      this.#globalTaskId = +targetId;
    }

    // Dnd arrow
    if (markerFolder) {
      const elArrow = document.createElement('DIV');

      const grid = this.#instance.$ui.getView('grid');
      const gridLeft = grid.$grid_data.getBoundingClientRect().left;

      const column = document.querySelector('.gantt_grid_head_text');
      const columnLeft = column.getBoundingClientRect().left;

      elArrow.innerHTML = dnd_arrow;
      elArrow.className = 'dnd_arrow';
      elArrow.style.marginLeft = `${columnLeft - gridLeft + 15}px`;

      markerFolder.appendChild(elArrow);
    }

    app.trigger('ganttview:contextMenu:close');
  }

  onBeforeRowDragEnd(id, newParentId, tindex) {
    this.#isChangingProjectsOrderInMultiview = false;
    this.isDragging = false;

    if (this.isAborting) {
      return false;
    }

    const task = this.#instance.isTaskExists(id) && this.#instance.getTask(id);
    const newParent = this.#instance.isTaskExists(newParentId) && this.#instance.getTask(newParentId);

    if (!task || !newParent) return;

    if (!this.#checkOnDepth(id)) {
      return false;
    }

    const isMultiview = this.#instance.config.multiview;
    const isMainMultiviewParent = isMultiview && newParent.id === 1;
    const isMoveTaskBetweenProjects = !isMainMultiviewParent && task.gantt_id !== newParent.gantt_id;

    if (isMoveTaskBetweenProjects) {
      return false;
    }

    const isSamePosition = +task.parent === +newParent.id && tindex === task.$local_index;

    if (isSamePosition) {
      return false;
    }

    const isChangingProjectsOrderInMultiview = isMultiview && !newParent.gantt_id && task.$level === 1;

    if (isChangingProjectsOrderInMultiview) {
      this.#isChangingProjectsOrderInMultiview = true;
    }

    return true;
  }

  onRowDragEnd(id, targetId) {
    if (this.#isChangingProjectsOrderInMultiview) {
      this.#instance.callEvent('onMultiviewProjectsOrderChange', [this.#getOrder(id)]);
      this.#isChangingProjectsOrderInMultiview = false;

      return;
    }

    userExtAnalytics.log('gantt_task_grid_drop');
  }

  dragEnd() {
    const element = document.querySelector('.gantt_transparent');

    if (element) {
      this.isAborting = true;

      // Trigger dhtmlx dragEnd method. Remove dhtmlx mousemove and mouseup dnd events.
      if (typeof Event === 'function') {
        element.dispatchEvent(new Event('mouseup', { bubbles: true }));
      } else {
        // IE11
        const event = document.createEvent('Event');

        event.initEvent('mouseup', true);
        element.dispatchEvent(event);
      }
    }
  }

  #getOrder(taskId) {
    return this.#instance.getSiblings(taskId).map(id => this.#instance.getTask(id).gantt_id);
  }

  #checkOnDepth(taskId) {
    let maxDepth = this.#instance.calculateTaskLevel(taskId);

    if (!maxDepth) {
      return false;
    }

    if (this.#instance.hasChild(taskId)) {
      this.#instance.eachTask(task => {
        if (this.#instance.calculateTaskLevel(task.id) > maxDepth) {
          maxDepth = this.#instance.calculateTaskLevel(task.id);
        }
      }, taskId);
    }

    return maxDepth < 14;
  }

  #openParent = _.debounce(function(isOpen, target) {
    if (isOpen && target && !target.$open) {
      target.$open = 1;
      this.#instance.render();
    }
  }, 500)
}

export default new Dnd();
